module.exports = __webpack_public_path__ + "img/picMain.91184c7c.png";